import axios from 'axios'
import i18n from '@/common/plugins/i18n'
import en from './en.json'
import zhTW from './zh-TW.json'

// The API returns error messages in Japanese only. For any other locale, translate them here:
// zh-TW uses zh-TW.json (falling back to English per message), every other locale uses en.json.
// Both dictionaries are hand-maintained and keyed by the Japanese text.

// FuelPHP placeholders (:0, :name, :label, :param:1, ...)
const TAG = /:(?:param:\d+|\w+)/g

const escapeRegExp = text => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

// Messages with placeholders are matched by regexp, longest fixed text first.
const buildPatterns = messages => Object.keys(messages)
  .filter(ja => ja.replace(TAG, '') !== ja)
  .map(ja => ({
    tags: ja.match(TAG),
    fixedLength: ja.replace(TAG, '').length,
    regexp: new RegExp('^' + ja.split(TAG).map(escapeRegExp).join('([\\s\\S]+?)') + '$'),
    translation: messages[ja]
  }))
  .filter(pattern => pattern.fixedLength >= 2)
  .sort((a, b) => b.fixedLength - a.fixedLength)

const createTranslator = ({ messages, labels }) => {
  const patterns = buildPatterns(messages)

  // Values filled into placeholders are translated too when they are field labels (品種, ...) or messages.
  const translateValue = value => labels[value] || messages[value] || value

  return message => {
    if (typeof message !== 'string') {
      return message
    }
    if (messages[message]) {
      return messages[message]
    }
    for (const pattern of patterns) {
      const match = pattern.regexp.exec(message)
      if (match) {
        const values = {}
        pattern.tags.forEach((tag, i) => {
          values[tag] = translateValue(match[i + 1])
        })
        return pattern.translation.replace(TAG, tag => (tag in values ? values[tag] : tag))
      }
    }
    return message
  }
}

const translators = {
  en: createTranslator(en),
  'zh-TW': createTranslator({
    messages: { ...en.messages, ...zhTW.messages },
    labels: { ...en.labels, ...zhTW.labels }
  })
}

axios.interceptors.response.use(null, error => {
  const data = error.response && error.response.data
  if (i18n.locale !== 'ja' && data && Array.isArray(data.messages)) {
    const translate = translators[i18n.locale] || translators.en
    data.messages = data.messages.map(translate)
  }
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/app/lang/api/index.js